import api, { paginado } from './apiClient'

/** `GET /machine-recipes?subCompanyId&search&limit&offset` */
export const getAllMachineReceipts = async data => {
  const response = await api.get('/machine-recipes', {
    params: {
      subCompanyId: data.subCompanyId,
      search: data.search || undefined,
      limit: data.limit,
      offset: data.offset,
    },
  })
  return { data: paginado(response) }
}

export const createMachineReceipt = async data => api.post('/machine-recipes', data)

export const editMachineReceipt = async data => {
  const { receiptMachineId, ...corpo } = data
  return api.patch(`/machine-recipes/${receiptMachineId}`, corpo)
}

export const deleteMachineReceipt = async data =>
  api.delete(`/machine-recipes/${data.receiptMachineId}`)

/** `POST /machine-recipes/bulk` — carga em lote. */
export const createBulkMachineReceipt = async items => api.post('/machine-recipes/bulk', { items })
